import { getRequestEvent } from "solid-js/web";
import { RIASRecordType, padId } from "~/lib";

export const getCognitoProfile = async () => {
	"use server";

	const { getUserFromEvent } = await import("~/_server/auth");
	
	const user = await getUserFromEvent();	

	return user;
};

export const getUserCertificatesServer = async (limit: number = 25) => {
	"use server";
	const { getUserFromEvent } = await import("~/_server/auth");
	const { getByUser, batchGet } = await import("~/_server/dynamoDB");

	const user = await getUserFromEvent(getRequestEvent());

	if (!user) return new Response("Unauthorized", { status: 401 });

	const c = await getByUser("CERTIFICATE", user.userId!, limit);

	const projectIds = Array.from(
		new Map(
			c?.items?.map(item => [
				item.parent,
				{ pk: `USER#${user.userId!}`, sk: item.parent },
			]),
		).values(),
	);
	const projects = await batchGet(projectIds);

	return { projects, certificates: c.items };
};

export const getUserSubscriptionsServer = async () => {
	"use server";

	const { getByUser } = await import("~/_server/dynamoDB");

	return await getByUser("SUBSCRIPTION");
};

export const getProjectCertificatesServer = async (projectId: number) => {
	"use server";

	const { runQueryCommand, RIASTABLE } = await import("~/_server/dynamoDB");

	const r = await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiByParent",
		KeyConditionExpression: "parent = :parent AND begins_with(sk, :prefix)",
		ExpressionAttributeValues: {
			":parent": padId(projectId, RIASRecordType.PROJECT),
			":prefix": "CERTIFICATE#",
		},
		ScanIndexForward: false,
	});

	return r?.items ?? [];
};

export const getByUserQueryServer = async (
	rowType: string,
	limit = 25,
	skId = null,
) => {
	"use server";

	const { getByUser } = await import("~/_server/dynamoDB");

	return await getByUser(rowType, null, limit, skId);
};

export const getByRowTypeServer = async (
	rowType: string,
	Limit: number = 25,
	ProjectionExpression:string|undefined = undefined,
	expressionAttributesNames = {},
	ExclusiveStartKey = undefined,
) => {
	"use server";

	const { runQueryCommand, RIASTABLE } = await import("~/_server/dynamoDB");

	return await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiByType",
		KeyConditionExpression: "recordType = :type",
		ExpressionAttributeValues: { ":type": rowType },
		ExpressionAttributeNames: expressionAttributesNames,
		ScanIndexForward: false,
		Limit,
		ProjectionExpression,
		ExclusiveStartKey,
	});
};

export const getProfileQueryServer = async (profileId?: number) => {
	"use server";

	const { getProfile } = await import("~/_server/dynamoDB");

	if (!profileId || profileId <= 0 || profileId == {}) {
		return null;
	}
	if (profileId > 0) {
		try {
			const r = await getProfile(profileId);
			return r;
		} catch (e) {
			console.log("getProfileQuery err", e);
		}
	}

	return null;
};
export const getCertifiersQueryServer = async () => {
	"use server";

	const { runQueryCommand, RIASTABLE } = await import("~/_server/dynamoDB");

	return await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiByType",
		KeyConditionExpression: "recordType = :type",
		ExpressionAttributeValues: {
			":type": "USER",
		},
		ScanIndexForward: false,
	});
};

export const getByPKQueryServer = async (pk: string, sk?: string) => {
	"use server";

	const { queryByPK } = await import("~/_server/dynamoDB");

	const r = await queryByPK(pk, sk);

	return r;
};
